import 'latest-createjs/lib/easeljs/easeljs';
import EventDispatcher from 'events';
import find from 'lodash/find';

export default class Scheme extends EventDispatcher {
    constructor(container) {
        super();

        let canvas = container.find('canvas');

        this.id = container.data('id');
        this.defaultFill = 'rgba(240, 65, 35, 0.1)';
        this.highlightFill = 'rgba(240, 65, 35, 0.5)';

        this.defaultFreePointFill = 'rgba(218, 218, 218, 0.1)';
        this.highlightFreePointFill = 'rgba(218, 218, 218, 0.5)';

        this._canvas = canvas;
        this._shapes = [];
        this._stage = new createjs.Stage(canvas[0]);
        this._stage.enableMouseOver();
        this._selectedShape = null;

        createjs.Ticker.addEventListener('tick', this._stage);

        canvas.on('touchstart', (e) => {
            if (e.touches.length  === 1) {
                let touch = e.touches[0];
                let rect = canvas[0].getBoundingClientRect();
                let scale = rect.width / parseFloat(canvas.attr('width'));

                this._shapes.forEach(shape => {
                    let point = shape.globalToLocal((touch.clientX - rect.left) / scale, (touch.clientY - rect.top) / scale);

                    if (shape.hitTest(point.x, point.y)) {
                        if (shape._highlighted == true) {
                            this.toggleShapeActivity(shape);
                        }
                    }
                });
            }
        });
    }

    addPoints(points) {
        points.forEach(item => {
            this.addPoint(item);
        });
    }

    addPoint(point) {
        if (!point.path) {
            return;
        }

        let coordinates = point.path.split(',');
        let shape = new createjs.Shape();

        if (point.is_free) {
            shape._fillCommand = shape.graphics.beginFill(this.defaultFreePointFill).command;
        } else {
            shape._fillCommand = shape.graphics.beginFill(this.defaultFill).command;
        }
        shape._id = point.id;
        shape._point = point;
        shape.cursor = 'pointer';

        for (let i = 0; i < coordinates.length; i += 2) {
            let x = coordinates[i];
            let y = coordinates[i + 1];

            if (i === 0) {
                shape.graphics.moveTo(x, y);
            } else {
                shape.graphics.lineTo(x, y);
            }
        }

        shape.graphics.closePath();

        this._stage.addChild(shape);
        this._shapes.push(shape);

        shape.on('mouseover', () => {
            if (shape._highlighted == true) {
                if (!this._selectedShape || this._selectedShape !== shape) {
                    if (shape._point.is_free) {
                        shape._fillCommand.style = 'rgba(218, 218, 218, 0.35)'
                    } else {
                        shape._fillCommand.style = 'rgba(240, 65, 35, 0.35)';
                    }
                }
            }
            else{
                for (let i = 0; i < this._shapes.length; i++) {
                    if (!this._shapes[i]._highlighted) {
                        this._shapes[i].cursor = 'default';
                    }
                }
            }
        });
        shape.on('mouseout', () => {
            if (shape._highlighted == true) {
                if (shape._point.is_free) {
                    shape._fillCommand.style = 'rgba(218, 218, 218, 0.5)'
                } else {
                    shape._fillCommand.style = 'rgba(240, 65, 35, 0.5)';
                }
            }
            else if ((!this._selectedShape || this._selectedShape !== shape) && !shape._highlighted) {
                if (shape._point.is_free) {
                    shape._fillCommand.style = this.defaultFreePointFill;
                } else {
                    shape._fillCommand.style = this.defaultFill;
                }
            }
        });
        shape.on('mousedown', downEvent => {
            if (shape._highlighted == true) {
                this._stage.on('stagemouseup', upEvent => {
                    if (
                        Math.abs(downEvent.nativeEvent.clientX - upEvent.nativeEvent.clientX) > 5 ||
                        Math.abs(downEvent.nativeEvent.clientY - upEvent.nativeEvent.clientY) > 5
                    ) {
                        return;
                    }

                    this.toggleShapeActivity(shape);
                }, null, true);
            }
        });
    }

    toggleShapeActivity(shape) {
        let selectedShape = this._selectedShape;

        if (selectedShape) {
            this.emit('unSelect', shape._point, selectedShape !== shape);
        }
        if (!selectedShape || selectedShape !== shape) {
            this.emit('select', shape._point);
        }
    }

    selectPoint(id) {
        this.unSelectPoint();

        let shape = find(this._shapes, {_id: id});

        if (!shape) {
            return;
        }

        if (shape._point.is_free) {
            shape._fillCommand.style = 'rgba(218, 218, 218, 0.8)';
        } else {
            shape._fillCommand.style = 'rgba(240, 65, 35, 0.8)';
        }

        this._selectedShape = shape;
    }

    unSelectPoint() {
        if (!this._selectedShape) {
            return;
        }

        if (this._selectedShape._highlighted) {
            if (this._selectedShape._point.is_free) {
                this._selectedShape._fillCommand.style = this.highlightFreePointFill;
            } else {
                this._selectedShape._fillCommand.style = this.highlightFill;
            }
        } else {
            if (this._selectedShape._point.is_free) {
                this._selectedShape._fillCommand.style = this.defaultFreePointFill;
            } else {
                this._selectedShape._fillCommand.style = this.defaultFill;
            }
        }
        this._selectedShape = null;
    }

    highlightPoint(id) {
        let shape = find(this._shapes, {_id: id});

        if (shape && !shape._highlighted) {
            if (shape._point.is_free) {
                shape._fillCommand.style = this.highlightFreePointFill;
            } else {
                shape._fillCommand.style = this.highlightFill;
            }
            shape._highlighted = true;
        }
    }

    unHighlightPoint(id) {
        let shape = find(this._shapes, {_id: id});

        if (shape && shape._highlighted) {
            if (shape._point.is_free) {
                shape._fillCommand.style = this.defaultFreePointFill;
            } else {
                shape._fillCommand.style = this.defaultFill;
            }
            shape._highlighted = false;
        }
    }

    unHighlightPoints() {
        this._shapes.forEach(shape => {
            if (shape._highlighted) {
                this.unHighlightPoint(shape._id);
            }
        });
    }

    clear() {
        if (this._selectedShape) {
            this.emit('unSelect', this._selectedShape._point, false);
        }

        this._stage.removeAllChildren();
        this._shapes = [];
    }

    destroy() {
        createjs.Ticker.removeEventListener('tick', this._stage);
        this.clear();
    }
}



// WEBPACK FOOTER //
// resources/assets/src/js/Scheme.js